import React, { useRef, useState, useEffect, useContext } from "react";
import edit from "../../../../assets/images/homepage/setting/general/edit.svg";
import editDark from "../../../../assets/images/homepage/setting/general/editDark.svg";
import useTheme from "hooks/observer";
import "./general.scss";
import Selections from "components/countrySelection/index";
import Button from "components/Button/index";
import Email from "components/Settings/Email/index";
import { Organization, ManageUser as MU } from "@induz/sdk";
import { useToast } from "components/Toaster/index";
import { signInContext } from "context/SigninContext";
import { createProfileThumbnail } from "utils/imageThumbnail";

// const initialDetailsData = [
//   { text: "Company Name", para: "Induz" },
//   { text: "Company Size", para: "1-50" },
//   { text: "Location", para: "India" }
// ];

function OrganizationGeneral({
  setEditProfile,
  editProfile,
  setManageUser,
  onProfileUpdated
}) {
  const [detailsData, setDetailsData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(
    sessionStorage.getItem("selectEmployee") ?? "0 - 10 Employees"
  );
  const [selectedCountry, setSelectedCountry] = useState(
    sessionStorage.getItem("selectCountry") ?? "India"
  );
  const [companyName, setCompanyName] = useState("");
  const [vatId, setVatId] = useState("");
  const [taxId, setTaxId] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [employeeDropdownOpen, setEmployeeDropdownOpen] = useState(false);
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");
  const [existingLogoBytes, setExistingLogoBytes] = useState(null);
  const [logoRemoved, setLogoRemoved] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [profilePicName, setProfilePicName] = useState(null);

  const imageMimeTypes = {
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    webp: "image/webp",
    gif: "image/gif",
    bmp: "image/bmp",
    svg: "image/svg+xml",
  };
  const getFileExtension = (filename) => {
    const match = filename.match(/\.(\w+)$/);
    return match ? match[1].toLowerCase() : null;
  };
  const getImageMimeType = (file) => {
    if (file?.type && file.type.startsWith("image/")) return file.type;
    const ext = getFileExtension(file?.name || "");
    return (ext && imageMimeTypes[ext]) || "image/png";
  };
  const readFileToUint8Array = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        resolve(new Uint8Array(e.target.result));
      };
      reader.onerror = () => reject(reader.error || new Error("Failed to read image"));
      reader.readAsArrayBuffer(file);
    });
  const resizeImageFile = (file, maxSize = 512) =>
    new Promise((resolve, reject) => {
      const imageUrl = URL.createObjectURL(file);
      const img = new Image();
      img.onload = async () => {
        try {
          const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
          const targetWidth = Math.max(1, Math.round(img.width * scale));
          const targetHeight = Math.max(1, Math.round(img.height * scale));
          const canvas = document.createElement("canvas");
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            URL.revokeObjectURL(imageUrl);
            reject(new Error("Canvas not supported"));
            return;
          }
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
          const mimeType = getImageMimeType(file);
          canvas.toBlob(async (blob) => {
            URL.revokeObjectURL(imageUrl);
            if (!blob) {
              reject(new Error("Failed to compress image"));
              return;
            }
            const buffer = await blob.arrayBuffer();
            resolve({ blob, bytes: new Uint8Array(buffer) });
          }, mimeType, 0.92);
        } catch (err) {
          URL.revokeObjectURL(imageUrl);
          reject(err);
        }
      };
      img.onerror = () => {
        URL.revokeObjectURL(imageUrl);
        reject(new Error("Failed to load image"));
      };
      img.src = imageUrl;
    });
  const isImageFile = (filename) => {
    const ext = getFileExtension(filename);
    return ext && Object.prototype.hasOwnProperty.call(imageMimeTypes, ext);
  };

  const theme = useTheme();
  const fileRef = useRef();
  const [orgnizationInstance, setOrgnizationInstance] = useState(null);
  // const [orgnizationInstance] = useState(null);
  const [imageArray, setImageArray] = useState(null);
  const showToast = useToast();

  // Initialize: fetch org details with forceRefresh so backend receives GetUser (profile/logo)
  useEffect(() => {
    const initializeOrg = async () => {
      const emailToUse = sessionStorage.getItem("mail") || undefined;
      try {
        const user = await MU.getUserDetails(emailToUse, true);
        if (user instanceof Organization) {
          setOrgnizationInstance(user);
        } else {
          console.error("Failed to initialize organization instance");
        }
      } catch (err) {
        console.error("Failed to load organization details:", err);
      }
    };
    initializeOrg();
  }, []);

  const { userMail } = useContext(signInContext);
  const orgEmail = userMail || sessionStorage.getItem("mail") || undefined;
  const handleEdit = () => {
    setEditProfile(true);
    // setCompanyName(detailsData[0].para);
  };

  const handleCancel = () => {
    setEditProfile(false);
    getUserDetails();
  };

  const detectImageMimeType = (bytes) => {
    if (!bytes || bytes.length < 4) return "image/png";
    const signature = Array.from(bytes.slice(0, 12));
    if (signature[0] === 0x89 && signature[1] === 0x50 && signature[2] === 0x4e && signature[3] === 0x47) return "image/png";
    if (signature[0] === 0xff && signature[1] === 0xd8 && signature[2] === 0xff) return "image/jpeg";
    if (signature[0] === 0x47 && signature[1] === 0x49 && signature[2] === 0x46) return "image/gif";
    if (signature[0] === 0x42 && signature[1] === 0x4d) return "image/bmp";
    if (signature[0] === 0x52 && signature[1] === 0x49 && signature[2] === 0x46 && signature[3] === 0x46 &&
      signature[8] === 0x57 && signature[9] === 0x45 && signature[10] === 0x42 && signature[11] === 0x50) return "image/webp";
    return "image/png";
  };

  const getUserDetails = async (forceRefresh = true) => {
    try {
      const user = await MU.getUserDetails(orgEmail, forceRefresh);
      if (!(user instanceof Organization)) {
        showToast("Failed to get organization instance", "error");
        return;
      }
      setOrgnizationInstance(user);
      const phoneNumber = user.getPhone();
      setPhoneNumber(phoneNumber || "");
      const address = user.getAddress();
      setAddress(address || "");
      const registrationNumber = user.getRegId();
      setRegistrationNumber(registrationNumber || "");
      const vatId = user.getVatId();
      setVatId(vatId || "");
      const taxId = user.getTaxId();
      setTaxId(taxId || "");
      const companyName = user.getName();
      const location = user.getLocation();
      setCompanyName(companyName || "");
      const logoBytes = user.getLogo?.();
      if (logoBytes && logoBytes.length > 0) {
        setExistingLogoBytes(logoBytes);
        const base64Pic = btoa(String.fromCharCode(...logoBytes));
        const mimeType = detectImageMimeType(logoBytes);
        setSelectedImg(`data:${mimeType};base64,${base64Pic}`);
      } else {
        setExistingLogoBytes(null);
        setSelectedImg("");
      }
      const updatedDetailsData = [
        { text: "Company Name", para: companyName },
        // { text: "Company Size", para: selectedEmployee },
        { text: "Location", para: location },
        { text: "VAT Id", para: vatId },
        { text: "Tax Id", para: taxId },
        { text: "Registration Number", para: registrationNumber },
        { text: "Phone Number", para: phoneNumber },
        { text: "Address", para: address }
      ];

      setDetailsData(updatedDetailsData);
    } catch (error) {
      showToast("Failed to get user details", "error");
      console.error("Failed to get user details:", error);
    }
  };

  const [loading, setLoading] = useState(false);
  const handleSave = async () => {
    if (!orgnizationInstance) return;

    // const updatedDetailsData = [...detailsData];
    // updatedDetailsData[0].para = companyName;
    // updatedDetailsData[1].para = selectedEmployee;
    // updatedDetailsData[2].para = selectedCountry;

    // setDetailsData(updatedDetailsData);
    // setDetailsData([]);
    setEditProfile(false);
    try {
      setLoading(true);
      const logoToSave = logoRemoved
        ? new Uint8Array(0)
        : (imageArray ?? existingLogoBytes ?? undefined);
      await MU.setOrganizationDetails(phoneNumber || "", address || "", taxId || "", vatId || "", registrationNumber || "", selectedCountry || "", logoToSave);
      sessionStorage.removeItem("userDetails");
      showToast("Organization details updated successfully", "success");
      // Force refresh to get latest data from backend
      await getUserDetails(true);
      setImageArray(null);
      setProfilePicName(null);
      setLogoRemoved(false);
      onProfileUpdated?.();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showToast("Failed to set organization details", "error");
      console.error("Failed to set organization details:", error);
    }
  };

  const uploadHandler = () => {
    fileRef.current?.click();
  };

  const handleImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (file.size > 4 * 1024 * 1024) {
      showToast("File size must be less than 5MB", "error");
      return;
    }
    if (!isImageFile(file.name)) {
      showToast("Unsupported image format", "error");
      return;
    }
    setProfilePicName(file.name);
    setLogoRemoved(false);
    const mimeType = getImageMimeType(file);
    const isNonResizable = mimeType === "image/gif" || mimeType === "image/svg+xml";
    if (isNonResizable) {
      readFileToUint8Array(file)
        .then((bytes) => {
          setImageArray(bytes);
          setSelectedImg(URL.createObjectURL(file));
        })
        .catch((err) => {
          console.error("Failed to read image:", err);
          showToast("Failed to read image", "error");
        });
      return;
    }
    createProfileThumbnail(file)
      .then(({ blob, bytes }) => {
        setImageArray(bytes);
        setSelectedImg(URL.createObjectURL(blob));
      })
      .catch(async (err) => {
        console.error("Failed to create logo thumbnail:", err);
        try {
          const bytes = await readFileToUint8Array(file);
          setImageArray(bytes);
          setSelectedImg(URL.createObjectURL(file));
        } catch (readErr) {
          console.error("Failed to read image:", readErr);
          showToast("Failed to load image", "error");
        }
      });
  };

  const getOrgName = async () => {
    if (!orgnizationInstance) return;
    try {
      const CompanyName = await orgnizationInstance.getName();

      setCompanyName(CompanyName);
    } catch (error) {
      console.error("Failed to get orgnization name:", error);
    }
  };

  const orgProfile = async () => {
    if (!orgnizationInstance) return;
    try {
      await MU.getProfilePic();

    } catch (error) {
      console.error("Failed to get orgnization profile picture:", error);
    }
  };

  useEffect(() => {
    if (orgnizationInstance) {
      // Use cache so we don't overwrite with stale backend data (e.g. logo after save)
      getUserDetails(false);
      getOrgName();
      orgProfile();
    }
  }, [orgnizationInstance]);

  const isFormValid =
    selectedEmployee.trim() &&
    selectedCountry.trim() &&
    (phoneNumber.trim().length >= 8 || phoneNumber.trim().length === 0);

  const orgInitial =
    ((orgEmail || sessionStorage.getItem("mail") || "@").trim().charAt(0).toUpperCase()) || "@";


  return (
    <div className={`General ${editProfile ? "GeneralEdit" : ""}`}>
      {editProfile ? (
        <div className="GeneralProfileEdit">
          <div
            className="GeneralProfileEditClose"
            onClick={handleCancel}
          >
            <span>✕</span>
          </div>
          <div className="GeneralProfileEditLeft">
            <div className="ProfilePhoto">
              <div className={`photo ${selectedImg ? "has-image" : ""}`}>
                {selectedImg ? (
                  <img
                    src={selectedImg}
                    alt="Uploaded"
                    className="uploaded-img"
                  />
                ) : (
                  <p>{orgInitial}</p>
                )}
              </div>
              <div className="upload">
                <input
                  type="file"
                  className="fileUpload"
                  ref={fileRef}
                  accept="image/png, image/jpeg, image/heic"
                  onChange={handleImageUpload}
                  hidden
                />
                {!selectedImg ? (
                  <h1 style={{ cursor: "pointer" }} onClick={uploadHandler}>
                    Upload picture
                  </h1>
                ) : (
                  <div className="options">
                    <p className="update" onClick={uploadHandler}>
                      Update
                    </p>
                    <p className="line"></p>
                    <p className="remove" onClick={() => {
                      setSelectedImg("");
                      setImageArray(null);
                      setProfilePicName(null);
                      setLogoRemoved(true);
                    }}>
                      Remove
                    </p>
                  </div>
                )}
                <p className="format">JPG, PNG, or HEIC, Max size of 5 MB</p>
              </div>
            </div>
            <div className="ProfileDetails">

              <div className="CompanyName CompanyName--vatId">
                <p>VAT Id</p>
                <input
                  type="text"
                  value={vatId}
                  onChange={(e) => setVatId(e.target.value)}
                  maxLength={255}
                />
              </div>
              <div className="CompanyName CompanyName--taxId">
                <p>Tax Id</p>
                <input
                  type="text"
                  value={taxId}
                  onChange={(e) => setTaxId(e.target.value)}
                  maxLength={256}
                />
              </div>
              <div className="CompanyName">
                <p>Registration Number</p>
                <input
                  type="text"
                  value={registrationNumber}
                  onChange={(e) => setRegistrationNumber(e.target.value)}
                  maxLength={70}
                />
              </div>

              <Selections
                selectedEmployee={selectedEmployee}
                setSelectedEmployee={setSelectedEmployee}
                sessionStorage={sessionStorage}
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                employeeDropdownOpen={employeeDropdownOpen}
                setEmployeeDropdownOpen={setEmployeeDropdownOpen}
                countryDropdownOpen={countryDropdownOpen}
                setCountryDropdownOpen={setCountryDropdownOpen}
              />
              <div className="CompanyName">
                <p>Phone Number</p>
                <div style={{ display: "flex", gap: "8px" }}>
                  <select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    style={{
                      fontSize: "14px",
                      padding: "6px 8px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      // background: "#f9f9f9",
                      width: "70px",
                      appearance: "none", // Removes default dropdown arrow styling
                      textAlign: "center",
                      cursor: "pointer"
                    }}
                  >
                    <option value="+91">+91 (IN)</option>
                    <option value="+1">+1 (US)</option>
                    <option value="+44">+44 (UK)</option>
                    <option value="+61">+61 (AU)</option>
                    <option value="+81">+81 (JP)</option>
                  </select>
                  <input
                    type="text"
                    value={phoneNumber.includes("-") ? phoneNumber.split("-")[1] : phoneNumber}
                    onChange={(e) => {
                      const onlyNumbers = e.target.value.replace(/\D/g, "");
                      setPhoneNumber(onlyNumbers);
                    }}
                    maxLength={15}
                    placeholder="Phone number"
                  />
                </div>
              </div>

              <div className="CompanyName">
                <p>Address</p>
                <input
                  type="text"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  maxLength={70}
                />
              </div>



            </div>
          </div>
          <div className="GeneralProfileEditRight">
            <Button type="white" title="Cancel" onClick={handleCancel} />
            <Button
              loading={loading}
              type="violet"
              title="Save"
              onClick={handleSave}
              disabled={!isFormValid}
            // disabled={companyName.length === 0}
            />
          </div>
        </div>
      ) : (
        <div className="GeneralProfile">
          <div className="GeneralDetails">
            <div className={`GeneralPhoto ${selectedImg ? "has-image" : ""}`}>
              {selectedImg ? (
                <img src={selectedImg} alt="Profile" className="uploaded-img" />
              ) : (
                <p>{orgInitial}</p>
              )}
            </div>
            <div className="GeneralPhotoText">
              {detailsData.map((item, index) => (
                <div
                  className={item.text === "VAT Id" || item.text === "Tax Id" ? "PhotoText PhotoText--scrollable" : "PhotoText"}
                  key={index}
                >
                  <p>{item.text}</p>
                  <h1>{index === 0 ? companyName : item.para}</h1>
                </div>
              ))}
            </div>
          </div>
          <div
            className="GeneralEdit"
            onClick={handleEdit}
            style={{ cursor: "pointer" }}
          >
            <img src={theme === "light" ? edit : editDark} alt="edit profile" />
          </div>
        </div>
      )}
      <Email />
    </div>
  );
}

export default OrganizationGeneral;
